import { createFileRoute, Outlet, redirect, useLocation } from '@tanstack/react-router'
import { useAuthStore } from '@/stores/auth-store'
import { AuthenticatedLayout } from '@/components/layout/authenticated-layout'

function AuthenticatedRouteComponent() {
  const location = useLocation()

  if (location.pathname.startsWith('/admin')) {
    return <Outlet />
  }

  return <AuthenticatedLayout />
}

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: ({ location }) => {
    const { auth } = useAuthStore.getState()

    const session = auth.user?.session
    if (!auth.user || !session) {
      throw redirect({
        to: '/sign-in',
        search: {
          redirect: location.href,
        },
      })
    }

    if (session.expires_at && session.expires_at * 1000 < Date.now()) {
      useAuthStore.getState().auth.reset()
      throw redirect({
        to: '/sign-in',
        search: {
          redirect: location.href,
        },
      })
    }
  },
  component: AuthenticatedRouteComponent,
})
